import { createApi } from '@reduxjs/toolkit/query/react';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';
import { AxiosError } from 'axios';
import axiosClient from 'utils/client';

const axiosBaseQuery =
  ({ baseOptions }: { baseOptions?: any } = {}) =>
  async ({ url, method, data, params, queryOptions }: any) => {
    try {
      const { LMS_BASE_URL } = getConfig();
      
      if (!LMS_BASE_URL) {
        throw new Error(`LMS_BASE_URL missing. getConfig()=${JSON.stringify(getConfig())}`);
      }

      const result = await axiosClient({
        url: new URL(url, LMS_BASE_URL).href,
        method,
        data,
        params,
        ...baseOptions,
        ...queryOptions,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status || err?.status,
          data: err.response?.data || err?.message || err,
        },
      };
    }
  };

const baseApiSlice = createApi({
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 30,
  endpoints: builder => ({}),
});

export default baseApiSlice;
